module.exports = __webpack_public_path__ + "img/hat_female_beanie.c38a38d2.png";